import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import '../Home.css';
import AppBrandingMark from '../AppBrandingMark';
import RefreshReferentielButton from '../RefreshReferentielButton';
import storageManager from '../../services/storageManager';
import { useMissionContext } from '../../context/MissionContext';

export default function MobileShell() {
  const {
    user,
    isOnline,
    isLoading,
    error,
    handleRefresh,
    handleSync,
    handleLogout,
    getDaysUntilExpiry,
  } = useMissionContext();

  const navigate = useNavigate();
  const daysUntilExpiry = getDaysUntilExpiry();

  return (
    <div className="app app--with-bottom-nav">
      <header className="header">
        <div className="header-top">
          <div className="logo-container">
            <AppBrandingMark theme="dark" />
          </div>
        </div>

        <div className="header-status">
          <div className={'status-badge ' + (isOnline ? 'online' : 'offline')}>
            <span className="status-icon">{isOnline ? 'O' : 'X'}</span>
            <span>{isOnline ? 'En ligne' : 'Hors ligne'}</span>
          </div>

          <div className="user-info">{user ? user.nom + ' ' + user.prenom : 'Utilisateur'}</div>

          {daysUntilExpiry !== null && daysUntilExpiry < 7 && (
            <div className="token-warning">
              Token expire dans {daysUntilExpiry} jour{daysUntilExpiry > 1 ? 's' : ''}
            </div>
          )}

          {error && <div className="error-badge">{error}</div>}

          <button className="refresh-button" onClick={handleRefresh} disabled={isLoading}>
            {isLoading ? 'Wait' : 'Refresh'}
          </button>

          <button className="sync-button" onClick={handleSync} disabled={isLoading || !isOnline}>
            {isLoading ? 'Wait' : 'Sync'}
          </button>

          <RefreshReferentielButton />

          <button
            className="frais-button"
            onClick={() => navigate('/notes-frais')}
            style={{
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Frais
          </button>
          <button
            className="nouveau-rapport-button"
            onClick={() => navigate('/nouveau-rapport')}
            style={{
              background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Nouveau rapport
          </button>

          <button className="logout-button" onClick={handleLogout}>
            Deconnexion
          </button>
        </div>
      </header>

      <main className="content content--padded-bottom">
        <Outlet />

        <div
          style={{
            marginTop: '20px',
            padding: '12px',
            background: '#f3f4f6',
            borderRadius: '8px',
            fontSize: '12px',
            color: '#6b7280',
            textAlign: 'center',
          }}
        >
          Derniere sync:{' '}
          {storageManager.getLastSync() ? new Date(storageManager.getLastSync()).toLocaleString('fr-FR') : 'Jamais'}
        </div>
      </main>

      <nav className="bottom-nav" aria-label="Navigation principale">
        <NavLink
          to="/"
          end
          className={({ isActive }) => 'bottom-nav__link' + (isActive ? ' bottom-nav__link--active' : '')}
        >
          <span className="bottom-nav__label">Accueil</span>
        </NavLink>
        <NavLink
          to="/missions"
          className={({ isActive }) => 'bottom-nav__link' + (isActive ? ' bottom-nav__link--active' : '')}
        >
          <span className="bottom-nav__label">Missions</span>
        </NavLink>
        <NavLink
          to="/calendrier"
          className={({ isActive }) =>
            'bottom-nav__link bottom-nav__link--calendar' + (isActive ? ' bottom-nav__link--active' : '')
          }
        >
          <span className="bottom-nav__label">Calendrier</span>
        </NavLink>
      </nav>
    </div>
  );
}
